import { Location } from "../types/api/Location";

export function formatLocation(
  location: Location | undefined,
  isEmbeded?: boolean
) {
  if (!location) return "";

  let formattedStr = `${location.name}, ${(location.details as any)?.region}, ${
    (location.details as any)?.country
  }`;

  if (isEmbeded) {
    formattedStr = `📍 ` + formattedStr;
  }

  return formattedStr;
}
